export enum AppRoutes {
  LEGITIMATION = "legitimation",
  LOGIN = "login",
}
